// first array is stages, second array is lines of dialog

import { randInt, randMember } from '../utils';
import { randName } from './randName';

type Story = {
  title: string;
  chapters: string[][];
};

type Template = {
  title: string;
  base: string[][];
  substitutions: { [id: string]: string[] };
};

const templates: Template[] = [
  {
    title: 'Paperclips',
    base: [
      [
        '{GM|Good morning|Greetings} ...',
        'I am {one of the|the} last of the [ALIEN_TYPE].',
        'We were once a great and powerful civilization.',
        'We {created|built} {an artificial intelligence|an AI|a digital agent|a superintelligence} to run the {largest|biggest|most productive} [OVERPRODUCED_ITEM] {factory|corporation} on our home planet.',
        'It was {a terrible|a horrible|an awful} mistake. {The system|Our agent|The AI} escaped our {control|safeguards}.',
        'All matter in our {solar|star|home} system has been {converted to|made into} [OVERPRODUCED_ITEM]s.',
        'Now it {expands|grows} at the speed of light, {consuming|converting} every {star|planet|solar system} it reaches.  {We need your help to|You are the only one who can} stop it!',
      ],
      [
        "You've proven to be the {hero|one} we so desparately needed. You've defeated the first wave of AI glyphs.",
        "You've saved many lives, but there is still more work to do.",
        'Good luck on the next wave of your journey ... hero.',
      ],
      [
        'How glad I am to see you still alive hero.',
        'The [SYSTEM_NAME] is learning. The [SYSTEM_NAME] is growing.',
        'By destroying the [SYSTEM_NAME] it has become stronger, faster.',
        'You will need to focus your mind hero.',
        'Good luck.',
      ],
      ['You are close now.', 'The [SYSTEM_NAME] knows of your power.'],
      [
        'The [SYSTEM_NAME] is {panicking|on its last legs|weakened now}.',
        "It's retreated to the [FINAL_GALAXY_NAME] galaxy.",
        "You must {travel|go|fly} there and put an end to The [SYSTEM_NAME]'s tyrannical rule over the universe.",
      ],
      [
        'Hero...',
        "You've saved {us all|the galaxy|the universe|the world|everything}. We {are forever in your debt|owe you one|can't thank you enough}.",
        'Thank you.',
      ],
    ],
    substitutions: {
      ALIEN_TYPE: ['Centaureans', 'Earthlings', 'Pixelglyphs'],
      OVERPRODUCED_ITEM: [
        'paperclip',
        'stapler',
        'cube',
        'sock',
        'fork',
        'floppy disk',
      ],
      FINAL_GALAXY_NAME: [randName(randInt(5, 10))],
      SYSTEM_NAME: ['system', 'agent', 'intelligence', 'superintelligence', ''],
    },
  },
  {
    title: 'Hacking',
    base: [
      [
        '{GM|Yo|Good morning|Hello} ...',
        'Thanks for {responding to|answering} my {message|dm|SOS}. Now that our {communication is encrypted|channel is secure} I {will|can} tell you {everything|the truth|the real story}.',
        '[EVIL_CORP], the {largest|biggest|most notorius} {social media|advertising|surveilance|boomer meme|q-anon meme|teen blood} {company|network|corporation|organization} {on the planet|in the world|in the galaxy|online}, is trying to control the metaverse.',

        'They want to {fill it with|use it for} {advertising|ads}.',
        'They murdered a [OCCUPATION] working on {an open|a decentralized|a free} {metaverse|social media protocol|digital world}.',
        'You need to {hack|break} into their {system|database|datacenter} {and|to} {get|copy|download|extract} the {files|videos|emails} that prove it.',
        'I have created this game interface to allow you to do so.',
        "Glyphs are {defensive|enemy|firewall} {programs|agents|bots|AI}. If they {get|touch|reach|trace} you, [EVIL_CORP] will {know your location|melt your headset|trace your ip|find you} and {you're dead|you're fucked|you're done|you will die|you die} {in real life|IRL|for real}.",
        'Good luck.',
      ],
      [
        'Amazing work.',
        "You've destroyed their first line of defense, but there's more to go.",
        "I'm sure their panicking now. They know someone is in.",
        'You have to hurry.',
      ],
      [
        "They're starting to attack {all known associates of|anyone with a connection to} the [OCCUPATION].",
        'We need to get through, get the {files|data}, and shut them down.',
      ],
      [
        'They got [NAME_1].',
        "I don't know where they took them.",
        "We've got to hurry.",
      ],
      ['So close now.', 'LFG'],
      [
        'We got em!',
        "Amazing work. I've sent the {files|data} to every {news outlet|reporter|network} {in the world|online|in the pixelverse}.",
        '[EVIL_CORP] is {finished|done|wiped out}.',
        'Signing off and deleting any record of this.',
        'See you in the {metaverse|pixelverse|next episode|next one}.',
      ],
    ],
    substitutions: {
      EVIL_CORP: ['Meta', 'Facebook', 'Instagram', 'Occulus'],
      OCCUPATION: ['researcher', 'programmer'],
      NAME_1: [randName(randInt(5, 8))],
    },
  },
  {
    title: 'PHD',
    base: [
      [
        'GM ...',
        'This must be {strange|a surprise|very strange|surreal} to you.',
        'I know you are the [JOB] who was {running tests|experimenting} to determine if your universe was a simulation.',
        'You are the first to have {proven|shown} that it is. Your {test|experiment} {worked|succeeded}. You are in my universe now.',
        'My name is [NAME]. I am also a [JOB] in this universe.',
        'I created your universe to {mine cryptocurrency|produce art|study primitive life|calculate pi|test if my universe is a simulation}.',
        '{The|My} {government|university} knows you have {escaped|come here|arrived} and they want to shut your universe off.',
        "I find your {carbon based culture|nft art|strange culture} beautiful. We can't let them destroy it. It's too {important|special|unique}.",
        'We need to work together to stop them.',
      ],
      ['Wow! What a rush.', "You're doing great.", "Let's keep going."],
      [
        'The government is trying to shut off the servers.',
        'The ship has back-up servers.',
        'If they get to the main servers this ship is the only hope for your universe.',
      ],
      [
        "They've destroyed the main servers.",
        'We need to protect this ship.',
        'The only way to do that is to keep fighting.',
        'Another swarm incoming.',
      ],
      [
        'YES! We are winning.',
        "They are scared of what they don't understand.",
        'They want to hold on to their power.',
        "They don't realize that we could work together to create a bright future.",
        "Let's finish this.",
      ],
      [
        'We did it :)',
        'Your universe is saved.',
        'I can send you back now.',
        'Take this device. You can use it to contact me.',
        'Good luck.',
      ],
    ],
    substitutions: {
      NAME: [randName(randInt(5, 8))],
      JOB: ['PhD student', 'grad student', 'scientist', 'intern'],
    },
  },
  {
    title: 'Vitalik',
    base: [
      [
        '{GM|Wake up|Good, you are awake} ...',
        'The shrink ray worked. You are now the size of {an atom|a single water mollecule|a human cell}.',
        "I've injected this {mini robot|microbot|nanobot} into [TARGET] as well. I will be able to communicate with you this way.",

        'The enemy {glyphs|bots} are attacking his blood cells. We need to stop them.',
        "We can't let [TARGET] {perish at the hands of|get murdered by|be killed by} the evil {central bank|VC fund|ad company|search engine|social network|hedge fund|oil company} [BANK_NAME]",
        "Get to your ship. We don't have much time now.",
      ],
      [
        'Good. We have broken through the first line of defense.',
        'There is more to go. [TARGET] just passed out.',
        'From what I can tell the ambulance is on the way.',
        "We can't let [BANK_NAME] win.",
      ],
      [
        "There's nothing the doctors can do. The {glyphs|nanobots} from [BANK_NAME] are {untraceable|unstoppable|incurable} by modern {technology|medicine}.",
        "It's all up to us.",
        'The fate of the {world|metaverse|pixelverse} depends on you.',
      ],
      [
        "[TARGET] has slipped into a coma. If we don't finish this it's all over.",
      ],
      [
        'This is it.',
        'If we can get through this stage we will have won. {LFG|Lets go}!!!',
      ],
      [
        'You did it!!',
        'You saved {decentralization|the pixelverse|the world} as we know it!',
        'Good work {anon|hero|pilot} and {good bye|see you later|safe travels}.',
      ],
    ],
    substitutions: {
      BANK_NAME: [randName(randInt(5, 8))],
      TARGET: [
        'Vitalik',
        'Nftboi',
        'Beeple',
        'Steve Buscemi',
        'MySpace Tom',
        'Niftynaut',
        'Sham',
        'Unfit5',
      ],
    },
  },
];

export const randStory = (): Story => {
  const { title, base, substitutions } = randMember(templates);
  const cache: any = {};
  return {
    title,
    chapters: base.map(chapter =>
      chapter.map(line =>
        line
          .replace(
            /\[([^\]]*)\]/g,
            (_, id: string) =>
              cache[id] ?? (cache[id] = randMember(substitutions[id])),
          )
          .replace(/\{([^\}]*)\}/g, (_, opts: string) =>
            randMember(opts.split('|')),
          ),
      ),
    ),
  };
};
